import { GameScene } from "../scene/GameScene";
import { useGameStore } from "../store/gameStore";
import { Hud } from "../ui/Hud";

export function GameApp() {
  const chooseBuildTool = useGameStore((state) => state.chooseBuildTool);
  return (
    <main
      className="app-shell"
      onContextMenu={(event) => {
        event.preventDefault();
        chooseBuildTool(null);
      }}
    >
      <GameScene />
      <Hud />
    </main>
  );
}

